module.exports = __webpack_public_path__ + "img/percent-icon.29015c60.svg";